// Define a class to collect and format lead data so it can be passed
// into a function to apply DNI, Guest Card, and Leasing Link
// attribution changes

export default class ECSAttributionObject {
  constructor (_providerName, _leadName, _leadPhone = null, _leadId, _paramId, _paramValue) {
    this.provider = _providerName
    this.leadParam = {
      id: _paramId,
      value: _paramValue
    }
    if (_leadPhone != null) {
      this.attribution = {
        phone: {
          sourceName: _leadName,
          leadId: _leadId,
          dniPhone: _leadPhone
        }
      }
    }
  }
}
